module.exports = __webpack_public_path__ + "static/media/goods_title_en.c7e0c97f.png";